import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stockinCreationPO: null,
  loading: false,
  error: null,
};

const stockinCreationPOSlice = createSlice({
  name: "stockinCreationPO",
  initialState,
  reducers: {
    fetchStockinCreationPOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchStockinCreationPOSuccess: (state, action) => {
      state.loading = false;
      state.stockinCreationPO = action.payload;
      state.error = null;
    },

    fetchStockinCreationPOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchStockinCreationPOStart,
  fetchStockinCreationPOSuccess,
  fetchStockinCreationPOFailure,
} = stockinCreationPOSlice.actions;

export default stockinCreationPOSlice.reducer;